module.exports = __webpack_public_path__ + "media/03.55f2e4e0.wav";